<template>
  <Modal v-model="distributionListFormatModal" :title="$t('key1006866')" width="500" class-name="distributionListFormatStyle"
    :transfer="false" :mask-closable="false" @on-visible-change="distributionListFormatChange">
    <Form ref="distributionListFormatForm" :model="distributionListFormatForm" :label-width="100" @submit.native.prevent>
      <Row style="width: 90%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1006867')" prop="type" class="radio_styles">
            <RadioGroup v-model="distributionListFormatForm.type">
              <Radio :label="1">{{ $t('key1006868') }}</Radio>
              <Radio :label="2">{{ $t('key1006869') }}</Radio>
            </RadioGroup>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="distributionListFormatModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="distributionListFormatBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {downloadTemplateFile} from "@/utils/common";

export default {
  name: "distributionListFormatModal",
  mixins: [Mixin],
  data() {
    return {
      distributionListFormatModal: false,
      distributionListFormatForm: {
        type: 1
      },
      pickingList: [],
      pathType: null,
    };
  },
  methods: {
    // 初始化数据
    initDistributionListFormat(data, type) {
      this.pickingList = [];
      data.map((item) => {
        this.pickingList.push(item.packageId);
      });
      this.pathType = type;
      this.distributionListFormatModal = true;
    },
    // 确定按钮
    distributionListFormatBtn() {
      // 纸质清单
      if (this.distributionListFormatForm.type === 1) {
        const {href} = this.$router.resolve({
          path: '/printPaperList',
          query: {
            data: this.pickingList.join(','),
            type: this.pathType
          }
        });
        window.open(href, '_blank');
      }
      // 表格文件
      else {
        let query = {
          packageIds: this.pickingList,
          printType: 2
        };
        let url = '';
        if (this.pathType === 'supplierOrderList') {
          url = api.post_packageInfo_printPrepareGoods;
        } else if (this.pathType === 'stockList') {
          url = api.post_packageInfo_printPrepareGoodsStock;
        }
        this.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            if (data) {
              this.distributionListFormatModal = false;
              this.$emit('updateSelect', true);
              let url = data.excelPath;
              downloadTemplateFile(url);
            }
          }
        });
      }
    },
    // 监听弹窗
    distributionListFormatChange(value) {
      if (!value) {
        this.pickingList = [];
        this.$refs['distributionListFormatForm'].resetFields();
      }
    }
  }
};
</script>

<style scoped>

</style>